module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back",
    staticStyle: {},
    on: {
      "click": _vm.previousGoods
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', [_vm._v("Hire Invoice")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Contract Series.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.invoiceList.contractSeries),
      callback: function($$v) {
        _vm.$set(_vm.invoiceList, "contractSeries", $$v)
      },
      expression: "invoiceList.contractSeries"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Contract Type")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.invoiceList.contractType),
      callback: function($$v) {
        _vm.$set(_vm.invoiceList, "contractType", $$v)
      },
      expression: "invoiceList.contractType"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper/Customer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.invoiceList.shippingCustomerName),
      callback: function($$v) {
        _vm.$set(_vm.invoiceList, "shippingCustomerName", $$v)
      },
      expression: "invoiceList.shippingCustomerName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper/Customer Contact")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.invoiceList.shipperCustomerContact),
      callback: function($$v) {
        _vm.$set(_vm.invoiceList, "shipperCustomerContact", $$v)
      },
      expression: "invoiceList.shipperCustomerContact"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper/Customer address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.invoiceList.customerAddress),
      callback: function($$v) {
        _vm.$set(_vm.invoiceList, "customerAddress", $$v)
      },
      expression: "invoiceList.customerAddress"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.vehicleDetailNumber.length > 0) ? _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('h3', {
    attrs: {
      "id": "vehicle"
    }
  }, [_vm._v("Vehicle Number:")])], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.vehicleNumberError))]), _vm._v(" "), (_vm.vehicleDetailNumber.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _vm._l((_vm.vehicleDetailNumber), function(item, index) {
    return (_vm.vehicleDetailNumber.length > 0) ? _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "15"
      }
    }, [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": item.vehicleTruckId,
        "name": 'vehicleID' + (index + 1),
        "id": 'vehicleID' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.Oncheck(item.vehicleTruckId)
        }
      },
      model: {
        value: (_vm.vehicleNumber[index]),
        callback: function($$v) {
          _vm.$set(_vm.vehicleNumber, index, $$v)
        },
        expression: "vehicleNumber[index]"
      }
    }, [_vm._v(_vm._s(item.regdNo))])], 1) : _vm._e()
  }), _vm._v(" "), (_vm.vehicleDetailNumber.length > 0) ? _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    on: {
      "change": function($event) {
        _vm.Oncheck('all')
      }
    },
    model: {
      value: (_vm.selectAll[0]),
      callback: function($$v) {
        _vm.$set(_vm.selectAll, 0, $$v)
      },
      expression: "selectAll[0]"
    }
  }, [_vm._v("All")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [(_vm.vehicleDetailNumber.length == 0) ? _c('h3', {
    staticClass: "error"
  }, [_vm._v("Note: You have to complete your hire vehicle booking.")]) : _vm._e()]), _vm._v(" "), (_vm.vehicleDetailNumber.length > 0) ? _c('md-layout', {
    attrs: {
      "md-flex": "60"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color",
    attrs: {
      "id": "addButtonLoader",
      "disabled": _vm.permissionStatus
    },
    on: {
      "click": _vm.submitInvoice
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  }), _vm._v(" "), (_vm.vehicleDetailNumber.length == 0) ? _c('h3', [_vm._v("Note")]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), (_vm.viewInvoice.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("All Invoices")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "hireModelnew1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.no")]), _vm._v(" "), _c('th', [_vm._v("Truck No")]), _vm._v(" "), _c('th', [_vm._v("Total Cost")]), _vm._v(" "), _c('th', [_vm._v("No of days")]), _vm._v(" "), _c('th', [_vm._v("From Date")]), _vm._v(" "), _c('th', [_vm._v("To Date")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.viewInvoice), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.vehicleName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.finalCost))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.days))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.invoiceStartDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("moment")(item.loginTime)))])])
  }))])])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ee9bf6c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/hireInvoice.vue
// module id = 2799
// module chunks = 0